import { SemesterEnum } from "@/model/data/fitnessStatistics/SemesterEnum";

export class GetFitnessStatisticsReportReqData {
    year: number;
    semester: SemesterEnum;
    branchId: number | undefined;
    installationName: string = "";
}
